import { render, staticRenderFns } from "./SpinsIco.vue?vue&type=template&id=f80a20fa&scoped=true"
import script from "./SpinsIco.vue?vue&type=script&lang=js"
export * from "./SpinsIco.vue?vue&type=script&lang=js"
import style0 from "./SpinsIco.vue?vue&type=style&index=0&id=f80a20fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80a20fa",
  null
  
)

export default component.exports